import { format } from 'date-fns';

export const formatDate = milisecondDate => {
  try {
    return format(new Date(milisecondDate), 'dd/MM/yyyy HH:mm');
  } catch {
    return '';
  }
};
